var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockUnactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9539 7.83187C14.9539 11.5878 11.8476 14.6637 7.97694 14.6637C4.1063 14.6637 1 11.5878 1 7.83187C1 4.07596 4.1063 1 7.97694 1C11.8476 1 14.9539 4.07596 14.9539 7.83187Z",
    stroke: "#8C8C8C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99139 7.83181H7.97698V2.93689",
    stroke: "#8C8C8C",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockUnactive);
export default __webpack_public_path__ + "static/media/clock-unactive.311f69479b490b9f8210dc34ebf06f0a.svg";
export { ForwardRef as ReactComponent };